export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./routing.vue?vue&type=template&id=ebe7e3f8"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/routing.vue?vue&type=template&id=ebe7e3f8
// module id = B5C3
// module chunks = 0